import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => (
  <footer>
    <div className="footer-inner">
      <div className="footer-brand">
        <div className="brand-name">University of American Atlantic</div>
        <p>
          A modern American higher education institution delivering innovative, flexible,
          and globally accessible education through advanced digital learning technologies.
          Accredited and internationally recognized.
        </p>
        <div className="footer-contact">
          Pinellas County, Florida, USA<br />
          +1 (404) 859-5563<br />
          info@uaa.education<br />
          www.uaa.education
        </div>
      </div>
      <div className="footer-col">
        <h4>Navigation</h4>
        <Link to="/">Home</Link>
        <Link to="/about">About UAA</Link>
        <Link to="/programs">Academic Programs</Link>
        <Link to="/student-verification">Student Verification</Link>
        <Link to="/apply">Admissions</Link>
        <Link to="/contact">Contact</Link>
      </div>
      <div className="footer-col">
        <h4>Programs</h4>
        <Link to="/programs">Engineering &amp; Technology</Link>
        <Link to="/programs">Business &amp; Economics</Link>
        <Link to="/programs">Social Sciences</Link>
        <Link to="/programs">Health Sciences</Link>
      </div>
    </div>
    <div className="footer-bottom">
      <span>&copy; {new Date().getFullYear()} University of American Atlantic. All rights reserved.</span>
      <span>www.uaa.education</span>
    </div>
  </footer>
);

export default Footer;
